/**
 * Adapted from https://github.com/uidotdev/usehooks/blob/v2.4.1/index.js
 */
import { useLayoutEffect, useState } from 'react';

export interface WindowSize {
  width: number | null;
  height: number | null;
}

export function useWindowSize(): WindowSize {
  const [size, setSize] = useState<WindowSize>({
    width: null,
    height: null,
  });

  useLayoutEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
}
